import React from 'react';

import fetch from '../../fetch';

import utils from '../../../utils';

import {Modal, message} from 'antd';

const prefixUrl = "surveystudentpublish/"

const DataGrid = {
    selections: [],
    refresh: function() {

    }
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids;
}

/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};


const columns = utils.columns([
    {key:'$index', label: '序号'},
    {key:'columnName1', label: '未知列', width: 140, renderType: "select"},
    {key:'columnName2', label: '未知列', width: 140, renderType: "select"},
    {key:'columnName3', label: '未知列', width: 140, renderType: "select"},
    {key:'columnName4', label: '未知列', width: 140, renderType: "select"},
    {key:'columnName5', label: '未知列', width: 140, renderType: "select"},
    {key:'columnName6', label: '未知列', width: 140, renderType: "select"},
    {key:'checkFlag', label: '数据状态', width: 150, render: (value)=> {
        if(+value === 1) {
            return '未检查'
        } else if(+value === 0) {
            return '检查通过'
        } else if(+value === 2) {
            return <span className="root-unchecked">检查不通过</span>
        }
        return '';
    }},
    {key:'errorDesc', label: '数据描述', width: 220},
]);

const querySearch = (keywords = {pageNum: 1, pageSize: 100}) => {
    return fetch.post(`${prefixUrl}excellist/${keywords.pageSize}`, keywords)
    .then(response => {
        return {
            data: response.payload.data,
            meta: response.payload.meta.extParams
        };
    })
    .then(response => (Object.assign({
        result: response.data.dataList || [],
        selects: (response.data.dataList || []).map(d => ({
            value: d.id,
            checked: false
        })),
        checked: false,
        total: response.data.total,
        pageIndex: response.data.pageNum,
        pageSize:response.data.pageSize,
        notify: (response.data.dataList || []).length ? '' : '暂无数据...',
        meta: response.meta
    })));
}

const create = (keywords) => {
    return fetch.post('/surveystudentpublish/excelcreate', keywords).then(response => {
        if(response.code == 200) {
            return response.payload.data;
        }
    }).catch(error => {
        return error;
    })
}

export default {
    getSelection: () => DataGrid.selections,
    onSelect,
    setRefresh,
    columns,
    querySearch,
    create
}